import script from "./SuperMaster.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperMaster.vue?vue&type=script&setup=true&lang=js"

import "./SuperMaster.vue?vue&type=style&index=0&id=390009d1&scoped=true&lang=css"
import "./SuperMaster.vue?vue&type=style&index=1&id=390009d1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390009d1"]])

export default __exports__